import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useUrlState(key) {
  const location = useLocation();
  const navigate = useNavigate();

  const getState = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    const value = searchParams.get(key);
    return value ? JSON.parse(decodeURIComponent(value)) : null;
  }, [location.search, key]);

  const setState = useCallback((value) => {
    const searchParams = new URLSearchParams(location.search);
    
    if (value) {
      searchParams.set(key, encodeURIComponent(JSON.stringify(value)));
    } else {
      searchParams.delete(key);
    }

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }, [key, location.pathname, location.search, navigate]);

  const clearState = useCallback(() => {
    setState(null);
  }, [setState]);

  return [getState(), setState, clearState];
}

export function createFilteredUrl(path, filters) {

  if (!filters) return path;
  
  return `${path}?filters=${encodeURIComponent(JSON.stringify(filters))}&search=${encodeURIComponent('')}`;

}

export function getFilteredUrlState(search) {
  const searchParams = new URLSearchParams(search);
  const filters = searchParams.get('filters');
  return filters ? JSON.parse(decodeURIComponent(filters)) : null;
}
